import MapDraw from '../mapDraw';

export const clearAllMarkers = () => {
  MapDraw.map?.markers.clearAll();
};
